import { executeRequest, Request } from '@jfs/network'
import { settlementApiConfig } from './config'

const responseParser = (data: any) => {
  return data
}

const generateSettlementFileReq = (tokens: any, reqBody: any, userAccessToken: string) => {
  const request: Request<{}> = {
    config: settlementApiConfig(tokens),
    apiPath: 'jfs/v1/merchant/generateSettlementReport',
    method: 'POST',
    cache: false,
    body: reqBody,
    headers: {
      Authorization: userAccessToken,
    },
  }
  return executeRequest(request).then((data) => {
    return responseParser(data)
  })
}

export { generateSettlementFileReq }
